const looksLikeHtml = (s: string) => /<\/?[a-z][\s\S]*>/i.test(s);

const normalizeToHtml = (raw: string) => {
  const v = raw ?? '';
  if (!v.trim()) return '<p></p>';

  if (looksLikeHtml(v)) return v;

  const escaped = v.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  return `<p>${escaped.replace(/\r?\n/g, '<br />')}</p>`;
};

export default normalizeToHtml;
